<div class="confirm-modal ig-modal input-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">{{ data.inputModalTitle }}</div>
    <div class="mt-3">
        <ig-field [label]="data.inputModalHelpText" [required]="true" [formControl]="form.get('text')"
            [(ngModel)]="value">
        </ig-field>
    </div>
    <mat-dialog-actions align="end">
        <ig-button class="btn-primary" size="md" #confirmButton [isAsync]="data.isAsync" (trigger)="confirm($event)">{{
            data.inputModalConfirmButtonText }}</ig-button>        
        <div class="cancel-btn ml-4" *ngIf="!confirmButton.isLoading" (click)="close()">
            {{ data.inputModalCancelButtonText }}
        </div>
    </mat-dialog-actions>
</div>